import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import RadarMapa from "@/pages/RadarMapa";
import RadarTablero from "@/pages/RadarTablero";
import RadarFicha from "@/pages/RadarFicha";
import RadarFichaDeepLink from "@/pages/RadarFichaDeepLink";
import RadarActividad from "@/pages/RadarActividad";
import RadarSettings from "@/pages/RadarSettings";
import RadarTierra from "@/pages/RadarTierra";
import RadarPlatform from "@/pages/RadarPlatform";
import Fuentes from "@/pages/Fuentes";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/fuentes" element={<Fuentes />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/radar/tierra" replace />} />
        <Route path="/radar" element={<RadarMapa />} />
        <Route path="/radar/tierra" element={<RadarTierra />} />
        <Route path="/radar/tablero" element={<RadarTablero />} />
        <Route path="/radar/actividad" element={<RadarActividad />} />
        <Route path="/radar/ajustes" element={<RadarSettings />} />
        <Route path="/radar/plataforma" element={<RadarPlatform />} />
        <Route path="/radar/:id" element={<RadarFichaDeepLink />} />
      </Route>
      <Route path="*" element={<Navigate to="/radar/tierra" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
